import React from 'react'
import { Link } from "react-router-dom";
import '../App.css';
import { Descriptions } from 'antd';

const LinkItem = (props) => {
    return (<Link to={props.item.link}><b>{props.item.data}</b></Link>);
}

const DescriptionObject = (props) => {

    return (
        <Descriptions size = "small" column = {1} bordered>
            {
                props.object.map((_, index) => {
                    if (props.object[index].link === undefined)
                    {
                        return <Descriptions.Item 
                            key = {index} 
                            label={props.object[index].title}><b>{props.object[index].data}</b>
                            </Descriptions.Item>
                    }
                    else
                    {
                        return <Descriptions.Item key = {index} label={props.object[index].title}><LinkItem item={props.object[index]}/></Descriptions.Item>
                    }
                })
            }
        </Descriptions>
        );
}

export default DescriptionObject;